// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oq-c";
export var backButton = "_oq-4";
export var backIcon = "_oq-5";
export var chevronShortcut = "_oq-6";
export var container = "_oq-1";
export var editor = "_oq-8";
export var editorWrapper = "_oq-7";
export var prefix = "_oq-2";
export var searchIcon = "_oq-3";
export var suffix = "_oq-9";
export var suffixContent = "_oq-a";
export var suffixText = "_oq-b";
export var wrapper = "_oq-0";